<template>
  <div class="hello">
    <img src="../../assets/logo.png">

    <p>U bent nu uitgelogd, u wordt doorverwezen...</p>

    <talking-bird text="Tot snel!"></talking-bird>
  </div>
</template>

<script>
import User from '../../services/api/User';

export default {
  name: 'Login',
  data() {
    return {};
  },
  mounted() {
    User.logout();

    setTimeout(() => {
      window.location.href = '/';
    }, 2000);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/pages/authentication/Logout.vue